import React from 'react';
import {Modal, List, Avatar, Spin, message, Layout, Menu, Form, Input, Button, Checkbox, Space, Col, Row, Image} from 'antd';
import {Breadcrumb} from "antd/lib/breadcrumb";
import {
    LoadingOutlined,
    EditOutlined,
    HomeOutlined,
    MenuUnfoldOutlined,
    MenuFoldOutlined,
    UserOutlined,
    LogoutOutlined,
} from '@ant-design/icons';

import BuddyMenu from "../BuddyMenu";
import BuddyTitle from "../BuddyTitle";
import ChatApp from "./ChatApp";

const { Header, Footer, Sider, Content } = Layout;


class Chat extends React.Component {

    constructor(...args) {
        super(...args);
        this.state = {
            modalVisible: false,
            loading: false,
            systemConfig: {},
            visiting: {},
            loginBuddy: "",
            collapsed: true
        };
    }

    toggleCollapsed = () => {
        this.setState({
            collapsed: !this.state.collapsed,
        });
    };

    loadSystemConfig(nextProps) {
        const {app} = nextProps
        let formData = new FormData()
        formData.append('app', app)

        let host = process.env.REACT_APP_HOST

        this.setState({loading: true})

        fetch(host + "/site/view/systemConfig", {method: 'POST', body: formData})
            .then(response => response.json())
            .then(data => {
                if(this.unmount) return;
                this.setState({
                    systemConfig: data.data.map.systemConfig,
                })
            })
    }

    loadAuth(buddyName) {
        let formData = new FormData()
        formData.append('buddyName', buddyName)

        let host = process.env.REACT_APP_HOST

        this.setState({loading: true})

        fetch(host + "/site/buddy/api/auth", {method: 'POST', body: formData, credentials: 'include',
            xhrFields: {
                withCredentials: true
            }})
            .then(response => response.json())
            .then(data => {
                if(this.unmount) return;

                if(data.success) {
                    if(data.data.map.loginBuddy) {
                        this.setState({
                            auth: data,
                            visiting: data,
                            loginBuddy: data.data.map.loginBuddy.buddyName,
                            // chatApp will be rendered directly in render(), no need to store it in state
                        })

                        this.setState({
                            loading: false,
                        })

                        console.log("load end")

                    } else {
                        window.location.href="/site/buddy/login"
                    }

                }

            })

    }

    componentDidMount() {
        console.log("mount")
        this.loadSystemConfig({app: this.props.app})
        // Try to extract buddyName from URL path like /site/buddy/:buddyName/chat
        let buddyName = this.props.buddyName;
        try {
            const pathname = window.location && window.location.pathname ? window.location.pathname : '';
            // split and filter out empty segments
            const parts = pathname.split('/').filter(Boolean); // e.g. ['site','buddy','bob','chat']
            const buddyIndex = parts.indexOf('buddy');
            if (buddyIndex !== -1 && parts.length > buddyIndex + 1) {
                const candidate = parts[buddyIndex + 1];
                if (candidate) buddyName = decodeURIComponent(candidate);
            }
        } catch (e) {
            // ignore and fallback to props
            console.warn('Failed to parse buddyName from path, fallback to props', e);
        }
        this.loadAuth(buddyName)
    }


    render() {

        return (
            <>
                <BuddyTitle content="AI好问好答" systemConfig={this.state.systemConfig}></BuddyTitle>

                <Layout>
                    <Header>
                        <Space style={{color:'#ffffff'}}>
                            {React.createElement(this.state.collapsed ? MenuUnfoldOutlined : MenuFoldOutlined, {
                                className: 'trigger',
                                onClick: this.toggleCollapsed,
                            })}
                        </Space>
                    </Header>
                    <Layout>

                        <Sider collapsedWidth="0" trigger={null} collapsible collapsed={this.state.collapsed}>
                            <BuddyMenu buddyName={this.state.loginBuddy} />
                        </Sider>
                        <Content style={{height:'auto'}}>

                            <Row justify="space-around">
                                <Col span={1}></Col>
                                <Col span={20}>
                                    {/* Render ChatApp directly and pass loginBuddy (will be empty until auth completes) */}
                                    <ChatApp buddyName={this.state.loginBuddy} />
                                </Col>
                                <Col span={1}></Col>
                            </Row>

                        </Content>
                    </Layout>

                </Layout>
            </>
        );

    }

}

export default Chat;

